import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [tenantId, setTenantId] = useState(1);
  const [tenantName, setTenantName] = useState('');

  useEffect(() => {
    const hostname = window.location.hostname;
    const params = new URLSearchParams(window.location.search);
    const tid = params.get('tenant_id');

    if (tid) {
      setTenantId(parseInt(tid));
      fetchTenantName(parseInt(tid));
    } else if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
      fetchTenantByDomain(hostname);
    }
  }, []);

  const fetchTenantName = async (id) => {
    try {
      const res = await axios.get(`https://app.hayahost.net/api/auth/tenant/${id}`);
      if (res.data.tenant) {
        setTenantName(res.data.tenant.name);
      }
    } catch (err) { console.error(err); }
  };

  const fetchTenantByDomain = async (domain) => {
    try {
      const res = await axios.get(`https://app.hayahost.net/api/auth/tenant-by-domain?domain=${domain}`);
      if (res.data.tenant) {
        setTenantId(res.data.tenant.id);
        setTenantName(res.data.tenant.name);
      }
    } catch (err) { console.error(err); }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const response = await axios.post('https://app.hayahost.net/api/auth/login', {
        username,
        password,
        tenant_id: tenantId
      });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      window.location.href = '/';
    } catch (err) {
      const msg = err.response?.data?.message || 'اسم المستخدم أو كلمة المرور خاطئة';
      setError(msg);
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>🏦 نظام الحوالات</h1>
        {tenantName && (
          <div style={styles.tenantBadge}>🏢 {tenantName}</div>
        )}
        <p style={styles.subtitle}>تسجيل الدخول</p>
        {error && <div style={styles.error}>{error}</div>}
        <form onSubmit={handleLogin}>
          <div style={styles.inputGroup}>
            <label style={styles.label}>اسم المستخدم</label>
            <input style={styles.input} type="text" value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="أدخل اسم المستخدم" required />
          </div>
          <div style={styles.inputGroup}>
            <label style={styles.label}>كلمة المرور</label>
            <input style={styles.input} type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة المرور" required />
          </div>
          <button style={styles.button} type="submit" disabled={loading}>
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)' },
  card: { background: 'white', borderRadius: '16px', padding: '40px', width: '400px', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' },
  title: { textAlign: 'center', color: '#1a237e', fontSize: '28px', marginBottom: '8px' },
  tenantBadge: { background: '#e3f2fd', color: '#1a237e', padding: '8px 15px', borderRadius: '20px', textAlign: 'center', marginBottom: '10px', fontWeight: 'bold' },
  subtitle: { textAlign: 'center', color: '#666', marginBottom: '30px' },
  error: { background: '#ffebee', color: '#c62828', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center' },
  inputGroup: { marginBottom: '20px' },
  label: { display: 'block', marginBottom: '8px', color: '#333', fontWeight: 'bold' },
  input: { width: '100%', padding: '12px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '16px', direction: 'rtl', outline: 'none', boxSizing: 'border-box' },
  button: { width: '100%', padding: '14px', background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer', fontWeight: 'bold' },
};

export default Login;